/**
 * TanStack Query hooks for `igaming-bonus-award-and-wager-through-tracking`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingBonusAwardAndWagerThroughTrackingQueryKeys,
	type CreateIgamingBonusAwardAndWagerThroughTrackingBody,
	type ListIgamingBonusAwardAndWagerThroughTrackingResponse,
	type IgamingBonusAwardAndWagerThroughTrackingRow,
} from "./api";

export function useIgamingBonusAwardAndWagerThroughTrackingList(): UseQueryResult<ListIgamingBonusAwardAndWagerThroughTrackingResponse, Error> {
	return useQuery({
		queryKey: igamingBonusAwardAndWagerThroughTrackingQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingBonusAwardAndWagerThroughTrackingCreate(): UseMutationResult<IgamingBonusAwardAndWagerThroughTrackingRow, Error, CreateIgamingBonusAwardAndWagerThroughTrackingBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBonusAwardAndWagerThroughTrackingQueryKeys.all });
		},
	});
}

export function useIgamingBonusAwardAndWagerThroughTrackingDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingBonusAwardAndWagerThroughTrackingQueryKeys.all });
		},
	});
}
